import axios from 'axios';

const api = axios.create({ baseURL: process.env.VUE_APP_API_HOST });

if (process.env.VUE_APP_CHAVE_EMPRESA) {
  api.defaults.headers.Authorization = process.env.VUE_APP_CHAVE_EMPRESA;
}

export default api;

export function apiSetToken(token) {
  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  } else if (process.env.VUE_APP_CHAVE_EMPRESA) {
    api.defaults.headers.Authorization = process.env.VUE_APP_CHAVE_EMPRESA;
  } else {
    api.defaults.headers.Authorization = null;
  }
}

export function setupApiOnResponseError(responseInterceptor) {
  api.interceptors.response.use(null, responseInterceptor);
}

export async function setupBaseURL() {
  console.log('Status Online (navigator):', navigator.onLine);
  
  if (process.env.NODE_ENV !== 'production' || !navigator.onLine) return;

  try {
    const { data } = await axios.get('/api-base-url');
    api.defaults.baseURL = data;
  } catch (error) {
    console.warn('Modo offline detectado ou falha ao buscar api-base-url. Carregando interface offline...', error.message);
    
  }
}
